var _path, _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPluswallet(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 139,
    height: 22,
    viewBox: "0 0 139 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_316_1274",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 139,
    height: 22
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M139 0H0V21.3431H139V0Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_316_1274)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M21.8885 7.6847V8.57757C21.8885 11.777 19.6047 14.443 16.5793 15.0345V10.3482C17.0875 9.83994 17.4002 9.1375 17.4002 8.36192V7.92305C17.4002 6.36936 16.1416 5.11076 14.588 5.11076H5.79297V1.10547H15.3093C18.9426 1.10547 21.8885 4.05143 21.8885 7.6847Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.0502 10.7718H10.2554V5.73242H5.79482V10.7718H0V15.2311H5.79482V20.9288H10.2554V15.2311H16.0502V10.7718Z",
    fill: "url(#paint0_linear_316_1274)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M23.4648 20.9004V0H28.054V20.9004H23.4648Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M39.335 20.9004V18.9923H39.2795C38.6439 20.2093 37.0676 21.2875 35.133 21.2875C31.4279 21.2875 30.1289 18.4122 30.1289 15.6478V7.13281H34.6904V14.5973C34.6904 16.146 35.0775 17.5282 36.7359 17.5282C38.3942 17.5282 39.1686 16.146 39.1686 14.5696V7.13281H43.7023V20.9004H39.3338H39.335Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M53.9601 11.1977C53.2412 10.5066 52.1907 9.95293 51.0847 9.95293C50.2272 9.95293 49.3709 10.2569 49.3709 11.0589C49.3709 11.861 50.1175 12.054 51.8868 12.4411C53.9878 12.9115 56.2831 13.962 56.2831 16.6431C56.2831 20.1263 53.2148 21.3433 50.3937 21.3433C48.1539 21.3433 45.8322 20.5967 44.3945 19.2146L46.9382 16.5334C47.7403 17.4187 48.9837 18.0821 50.3117 18.0821C51.0583 18.0821 51.9423 17.7781 51.9423 16.8928C51.9423 16.0075 51.0847 15.7591 49.2057 15.3165C47.2976 14.8738 45.1966 13.9065 45.1966 11.3074C45.1966 8.01713 48.2926 6.69043 50.9195 6.69043C52.9651 6.69043 55.0938 7.35379 56.4483 8.62625L53.9601 11.1977Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M79.8617 1.32669L76.7102 14.3477H76.6269L73.116 1.32669H68.1951L64.7119 14.3477H64.6287L61.5326 1.32669H56.4453L62.0018 20.9004H66.702L70.5723 7.65749H70.6556L74.5259 20.9004H79.1983L84.7825 1.32669H79.8617ZM90.8384 6.69021C88.5987 6.69021 86.3047 7.49228 84.7006 9.01318L86.9958 11.4736C87.8256 10.6993 89.0968 10.0637 90.3958 10.0637C91.8057 10.0637 92.8839 10.6993 92.8839 12.0537V12.2744C88.8749 12.2744 84.0372 12.9378 84.0372 16.9191C84.0372 20.1539 86.8571 21.2321 89.0413 21.2321C90.672 21.2321 92.2483 20.5688 92.9394 19.435H93.0227V20.9004H97.1692V13.9605C97.1692 8.95643 95.4554 6.68895 90.8384 6.68895V6.69021ZM93.0227 15.3717C93.0227 17.0856 91.9999 18.1916 90.1751 18.1916C89.2633 18.1916 88.2115 17.8322 88.2115 16.7816C88.2115 15.151 90.4513 14.9013 92.4413 14.9013H93.0214V15.3717H93.0227ZM107.51 20.9004H112.1V0H107.51V20.9004ZM99.9348 20.9004H104.524V0H99.9348V20.9004ZM138.999 10.5328V7.13286H135.764V3.51094H131.314V7.13286H129.13V10.5328H131.342V16.339C131.342 19.2698 132.559 21.2321 136.235 21.2321C137.202 21.2321 138.253 21.0379 138.862 20.8172L138.806 17.4992C138.474 17.6379 137.922 17.7199 137.479 17.7199C136.181 17.7199 135.766 17.0566 135.766 15.7841V10.5316H139L138.999 10.5328ZM121.775 6.69021C117.601 6.69021 114.338 9.56555 114.338 14.0715C114.338 18.5775 117.766 21.3431 121.914 21.3431C124.706 21.3431 126.862 20.2926 128.161 18.4123L125.01 16.4222C124.402 17.252 123.407 17.8599 121.969 17.8599C120.338 17.8599 118.817 16.7816 118.679 15.2607H128.659C128.687 14.9291 128.687 14.5419 128.687 14.1825C128.687 9.48232 125.839 6.69021 121.775 6.69021ZM118.679 12.4409C118.79 11.031 120.061 9.81399 121.803 9.81399C123.544 9.81399 124.511 11.0032 124.511 12.4409H118.678H118.679Z",
    fill: "url(#paint1_linear_316_1274)"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_316_1274",
    x1: -1.70707e-7,
    y1: 12.8628,
    x2: 16.0161,
    y2: 12.8628,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#6976E1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.187019,
    stopColor: "#8977DA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.507154,
    stopColor: "#BF79CE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.687004,
    stopColor: "#CC8AB0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E2A77C"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_316_1274",
    x1: 56.4453,
    y1: 10.0144,
    x2: 138.825,
    y2: 10.0144,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#6976E1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.187019,
    stopColor: "#8977DA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.507154,
    stopColor: "#BF79CE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.687004,
    stopColor: "#CC8AB0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E2A77C"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPluswallet);
export default __webpack_public_path__ + "static/media/pluswallet.171b45fd2f398c397c9dd6fb65bfbb0b.svg";
export { ForwardRef as ReactComponent };